import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  form: {
    marginTop: "6rem",
  },
  button: {
    marginTop: "1rem",
    color: "#7289da",
    borderColor: "#7289da",
  },
}));

export default useStyles;
